// extracted by mini-css-extract-plugin
export var block = "ListItem-module--block--4025e";
export var container = "ListItem-module--container--5b3b8";
export var description = "ListItem-module--description--d7138";
export var heading = "ListItem-module--heading--227e3";
export var hide = "ListItem-module--hide--558b6";
export var icon = "ListItem-module--icon--876d4";
export var image = "ListItem-module--image--09061";
export var list = "ListItem-module--list--96c57";
export var pages = "ListItem-module--pages--3d6f2";
export var price = "ListItem-module--price--2e054";
export var product = "ListItem-module--product--83337";
export var productTab = "ListItem-module--productTab--3bba8";
export var standard = "ListItem-module--standard--ae630";
export var tag = "ListItem-module--tag--7522f";
export var title = "ListItem-module--title--2013e";
export var wrapper = "ListItem-module--wrapper--23010";